export default __webpack_public_path__ + "static/normalized_yahoofinance-7f75f9aa0b8ceea3c44e0cb70e6b0e82.svg";